import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Euro, Percent, Clock, Heart, Inbox } from "lucide-react";

function Stat({ icon, label, value, sub, testId }) {
  return (
    <div className="sc-card" data-testid={testId}>
      <div className="flex items-center gap-2 text-xs uppercase tracking-wider font-semibold text-slate-500">{icon}{label}</div>
      <div className="mt-2 text-3xl font-extrabold text-slate-900">{value}</div>
      {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
    </div>
  );
}

export default function ManagerStats({ refreshKey }) {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/manager/stats").then((r) => setStats(r.data)).catch(() => {}); }, [refreshKey]);
  if (!stats) return null;

  return (
    <div className="mt-8" data-testid="manager-stats">
      <h2 className="text-2xl font-bold text-slate-900">Statistiques · {stats.month}</h2>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat testId="stat-revenue" icon={<Euro className="w-4 h-4 text-emerald-600" />} label="Revenus du mois" value={`${stats.revenue.toFixed(2)} €`} sub={`${stats.paid_sessions} séance(s) réglée(s)`} />
        <Stat testId="stat-fill-rate" icon={<Percent className="w-4 h-4 text-indigo-600" />} label="Taux de remplissage" value={`${stats.fill_rate} %`} sub={`${stats.booked_slots}/${stats.total_slots} créneaux réservés`} />
        <Stat testId="stat-best-hours" icon={<Clock className="w-4 h-4 text-orange-500" />} label="Meilleurs créneaux" value={stats.best_hours.length ? stats.best_hours.map((h) => `${h.hour}h`).join(" · ") : "—"} sub={stats.best_hours.length ? `${stats.best_hours[0].count} réservation(s) à ${stats.best_hours[0].hour}h` : "Pas encore de réservation confirmée"} />
        <Stat testId="stat-pending" icon={<Inbox className="w-4 h-4 text-amber-600" />} label="Demandes en attente" value={stats.pending_requests} sub="à valider" />
      </div>
      {stats.per_room.length > 0 && (
        <div className="mt-3 sc-card overflow-x-auto">
          <table className="w-full text-sm" data-testid="stats-per-room">
            <thead className="text-xs uppercase tracking-wider text-slate-500 text-left">
              <tr><th className="py-1">Salle</th><th>Créneaux</th><th>Remplissage</th><th>Revenus</th><th><Heart className="w-3.5 h-3.5 inline" /> Favoris</th></tr>
            </thead>
            <tbody>
              {stats.per_room.map((r) => (
                <tr key={r.id} className="border-t border-slate-100" data-testid={`stats-room-${r.id}`}>
                  <td className="py-2 font-semibold text-slate-900">{r.name}</td>
                  <td>{r.booked}/{r.slots}</td>
                  <td><div className="flex items-center gap-2"><div className="w-24 h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-indigo-500" style={{ width: `${r.fill_rate}%` }} /></div>{r.fill_rate} %</div></td>
                  <td className="text-emerald-700 font-semibold">{r.revenue.toFixed(2)} €</td>
                  <td>{r.favorites}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
